<template>
    <Header subTitle="Contactez-nous 📩" />

    <Main>
        <FullContainer>
            <div class="flex-container">
                <div class="contact-infos">
                    <h2>Besoin d'aide pour votre projet ? On est à votre écoute !</h2>
                    <p>
                        Nous sommes là pour répondre à toutes vos questions et vous accompagner dans vos projets de
                        développement web. Que ce soit pour une demande de devis, des conseils techniques ou simplement
                        pour discuter de vos idées, n'hésitez pas à nous contacter.
                    </p>

                    <h3>🕒 Horaires d'ouverture :</h3>
                    <ul>
                        <li>🗓 Lundi - Vendredi</li>
                        <li>⏰ Matin : 9h - 12h</li>
                        <li>⏰ Après-midi : 14h - 18h</li>
                    </ul>
                </div>

                <ContactForm />
            </div>
        </FullContainer>
    </Main>
</template>

<script setup>
useSeoMeta({
    title: "Byte Hive — Contactez-nous pour vos projets web",
    description: "Vous avez un projet en tête ? Discutons-en ! Que ce soit pour une landing page, un site web ou une expertise technique, contactez Byte Hive pour avancer ensemble.",
    ogTitle: "Byte Hive — Contactez-nous pour vos projets web",
    ogDescription: "Vous avez une idée ou un besoin spécifique ? Notre équipe est prête à vous écouter et à vous accompagner dans la réalisation de vos projets numériques.",
    ogImage: "https://byte-hive.fr/byte-hive-og-image.png",
    ogUrl: "https://byte-hive.fr/contact",
    ogType: "website"
})
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
